export default [
  {
    path: '/profile/self-employed',
    name: 'selfEmployed',
    component: () => import('@/pages/profile/SelfEmployed'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/self-employed/activation/:id',
    name: 'activationSelfEmployed',
    component: () => import('@/pages/profile/ActivationSelfEmployed'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:publicId/check',
    name: 'transactionDeclaration',
    component: () => import('@/pages/profile/TransactionDeclaration'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/pages/main/Notifications'),
    meta: {
      requiresAuth: true,
    },
  },
];
